import { createI18n } from 'vue-i18n'

import sl from './locales/sl'

export type AvailableLocales = 'sl'

const i18n = createI18n({
    legacy:          false,
    globalInjection: true,
    locale:          'sl',
    messages:        { sl },
})

export default i18n
